(() => {
  if (window.hidockJapanNewsletterMain) return;
  window.hidockJapanNewsletterMain = true;
  const errorMessage = document.currentScript?.dataset.jpNewsletterError || 'We could not complete your signup. Please try again.';
  const pending = new WeakSet();
  const approved = new WeakMap();
  const endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=TWRNvY';
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.querySelector('input[name="form_type"]')?.value !== 'customer') return;
    if (!form.querySelector('input[name="contact[tags]"]')?.value.split(',').map(x => x.trim()).includes('newsletter')) return;
    const email = form.querySelector('input[name="contact[email]"]');
    if (!email || approved.get(form) === email.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form) || !form.reportValidity()) return;
    pending.add(form);
    const submitter = event.submitter;
    const buttons = [...form.querySelectorAll('button[type="submit"], input[type="submit"]')];
    const disabledBefore = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    let error = form.querySelector('[data-jp-newsletter-error]');
    if (error) error.remove();
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {'Content-Type': 'application/vnd.api+json', revision: '2026-07-15'},
        signal: controller.signal,
        body: JSON.stringify({data: {
          type: 'subscription',
          attributes: {
            custom_source: 'HiDock Japan storefront newsletter',
            profile: {data: {type: 'profile', attributes: {
              email: email.value.trim(),
              locale: 'ja-JP',
              properties: {signup_market: 'JP', signup_store: 'jp.hidock.com', preferred_language: 'ja'},
              subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
            }}}
          },
          relationships: {list: {data: {type: 'list', id: 'TV4bTt'}}}
        }})
      });
      if (!response.ok) throw new Error('Subscription not accepted');
      approved.set(form, email.value.trim());
      buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; });
      form.removeAttribute('aria-busy');
      if (submitter && submitter.form === form && !submitter.disabled) form.requestSubmit(submitter);
      else form.requestSubmit();
    } catch (exception) {
      error = document.createElement('p');
      error.dataset.jpNewsletterError = '';
      error.setAttribute('role', 'alert');
      error.style.cssText = 'margin-top:12px;font-size:14px;line-height:1.6;';
      error.textContent = errorMessage;
      form.appendChild(error);
      buttons.forEach((button, index) => { button.disabled = disabledBefore[index]; });
      form.removeAttribute('aria-busy');
    } finally {
      clearTimeout(timeout);
      pending.delete(form);
    }
  }, true);
})();
